var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCsharp48Line = function SvgIconCsharp48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.66 22.22 2.36-2.44c-2.37-2.29-6.21-2.29-8.58 0-1.16 1.13-1.81 2.63-1.81 4.23 0 1.6.64 3.1 1.81 4.23 1.18 1.14 2.74 1.71 4.29 1.71 1.55 0 3.11-.57 4.29-1.71l-2.36-2.44a2.785 2.785 0 0 1-3.85 0c-.5-.48-.77-1.11-.77-1.78 0-.67.27-1.3.77-1.78a2.785 2.785 0 0 1 3.85 0v-.02Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.19 15.08-11.8-6.43c-.87-.47-1.91-.47-2.78 0l-11.8 6.43a2.9 2.9 0 0 0-1.51 2.55v12.74c0 1.06.58 2.04 1.51 2.55l11.8 6.43c.43.24.91.35 1.38.35.47 0 .95-.12 1.39-.35l11.8-6.43a2.9 2.9 0 0 0 1.51-2.55V17.63c0-1.06-.58-2.04-1.51-2.55h.01ZM35.3 30.07 24 36.23l-11.3-6.16V17.92L24 11.76l11.3 6.16v12.15Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.31 29h2.54l.33-1.85h1.36L29.21 29h2.54l.33-1.85h1.87v-2.5h-1.43l.21-1.19h1.62v-2.5h-1.18l.34-1.95h-2.54l-.34 1.95h-1.36l.34-1.95h-2.54l-.34 1.95h-1.98v2.5h1.54l-.21 1.19h-1.73v2.5h1.29L25.31 29Zm3.52-5.55h1.36l-.21 1.19h-1.36l.21-1.19Z",
    fill: "current"
  })));
};
export default SvgIconCsharp48Line;